module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive"
  }, [_vm._v(_vm._s(_vm.$t('titles.additems', {
    additems: 'Add new item'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "mb4-ns f3"
  }, [_vm._v("\n      Please select a category:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-grid"
  }, _vm._l((_vm.categories), function(category, index) {
    return (!_vm.isNotAllowedCategory(_vm.is_active_coverage_restrictions, _vm.coverage_restriction_details, category.name, category.id)) ? _c('div', {
      key: index,
      staticClass: "pa3 bg-white account-card mb2-m pointer",
      on: {
        "click": function($event) {
          return _vm.chooseCategory(category)
        }
      }
    }, [_c('div', {
      staticClass: "responsive-card"
    }, [_c('div', {
      staticClass: "flex flex-row items-center mb2"
    }, [_c('img', {
      staticClass: "mr1 w-20-l width-responsive-icon filter-shadow",
      attrs: {
        "alt": "",
        "src": category.icon
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-column"
    }, [_c('div', {
      staticClass: "pl2 ttc f4 mb2 mb0-ns"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('span', {
      staticClass: "pl2 f6 inter color-text text-responsive-not"
    }, [_vm._v(" " + _vm._s(category.description))])])]), _vm._v(" "), _c('span', {
      staticClass: "f6 inter color-text text-responsive"
    }, [_vm._v(" " + _vm._s(category.description))])])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.showNotCoveredModal) ? _c('ak-modal', {
    attrs: {
      "title": "You have to upgrade your plan to cover this category"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n          This category is not covered by your currently selected coverage\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex-ns flex-wrap justify-end",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.useDeviceRestrictions) ? _c('div', {
    staticClass: "order-1 mb3 mb0-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.debounceMethod(function () { return _vm.updateCoverage(_vm.coverage_upgrade.id); })
      }
    }
  }, [_vm._v("Upgrade\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a3295784", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3295784","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddDeviceCategory.vue
// module id = 1488
// module chunks = 0